import gql from "graphql-tag";

export const ENTITY_VALUES_FRAGMENT = gql`
    fragment EntityValues on Entity {
        id
        key {
            ulid
        }
        legalAddress {
            countryCode
            city
            state
            streetAddress
            postalCode
        }
        physicalAddress {
            countryCode
            city
            state
            streetAddress
            postalCode
        }
        additionalProperties
        legalForm
        name
        alternativeNames {
            localNames
            previousNames
            shortNames
        }
        nationality
        natureOfBusiness
        ownershipType
        primaryCountryCode
        primaryIndustryCode
        primaryIndustryDescription
        dateOfIncorporation
        registrationStatus
        regulationStatus
        companyRegulators {
            name
            code
        }
        regulatoryBodyName
        riskLevel
        riskScore
        shareCapital
        stockExchangeOfPrimaryListing
        totalAnnualRevenue
        totalAssets
        totalShares
        isArchived
        identificationNumber {
            type
            number
        }
        highRiskIndustryDesignation
        externalIdentifiers {
            type
            id
        }
        linesOfBusiness
        exchangeTradedStatus
        businessRelationship
        createdDate
        description
        entityType
        industryClassifiers {
            classifier
            code
            description
        }
        companyIdentifiers {
            identifier
            code
            startDate
            expiryDate
            status
        }
        freeFloat
        sharesOutstanding
        corporateRegistry {
            authority
            registrationNumber
            dateOfIncorporation
            registrationStatus
        }
        fiscalYearEndDate
        sourceOfFunds
        stockExchanges {
            name
            code
        }
        gender
        individualIdentifiers {
            identifier
            code
            startDate
            expiryDate
            status
        }
        sourceOfWealth
        dateOfBirth
        addresses {
            type
            streetAddress
            city
            state
            postalCode
            countryCode
        }
        subtype
        placeOfBirth {
            city
            countryCode
        }
        nationalities {
            countryCode
        }
        freeFloatPercentage
        childMergedEntities {
            key {
                ulid
            }
            name
        }
        entitySource {
            sourceType
            name
        }
    }
`;

export const ENTITY_PROCESS_FRAGMENT = gql`
    fragment EntityProcess on ProcessInterface {
        __typename
        id
        uid
        hasProcessHistory
        processHistory {
            reportUrl
        }
        title
        description
        created
        status
        finished
        activeTask {
            assignable
            id
            uid
            title
        }
    }
`;
export const ENTITY_LOB_TERMINATIONS_FRAGMENT = gql`
    fragment LobTerminations on LOBTerminationType {
        timestamp
        lineOfBusiness: lobType
        externalIdentifier: lobId
    }
`;

export const ENTITY_DETAILS_QUERY = gql`
    query EntityDetails($id: ID!, $ulid: String!) {
        entity(id: $id) {
            ...EntityValues
            relations {
                key {
                    ulid
                }
                role
                shareType
                votingRightsPercentage {
                    mantissa
                    exponent
                }
                fromKey {
                    ulid
                }
                toKey {
                    ulid
                }
                fromEntity {
                    ...EntityValues
                }
                toEntity {
                    ...EntityValues
                }
                type
                furtherInformation {
                    dataSource
                    dateOfRetrieval
                }
                shareholdingPercentage {
                    mantissa
                    exponent
                }
                shareholdingValue
                sharesOwned
                id
            }
            hasBeenMerged
            rootMergedEntity {
                key {
                    ulid
                }
                name
            }
            continuousMonitoring {
                ulid
                entityKey {
                    ulid
                }
                pollingFrequency
                searchEngine
                status
                clientName
                monitorRelatedEntities
            }
            entityPolicies {
                id
                entity {
                    key {
                        ulid
                    }
                }
                scheduledDate
                lastExecuted
                sentryPolicy {
                    ulid
                    processName
                    policyType
                    pollingFrequency
                    policyName
                    searchEngine
                }
            }
            processes {
                ...EntityProcess
            }
        }
        lobTermination(entityUlid: $ulid) {
            ...LobTerminations
        }
        SentryPolicySchema: jsonSchema(schema: "arachnys.sentry.SentryPolicy")
        EntitySchema: jsonSchema(schema: "arachnys.entities.Entity")
        RelationSchema: jsonSchema(schema: "arachnys.entities.Relation")
    }
    ${ENTITY_VALUES_FRAGMENT}
    ${ENTITY_LOB_TERMINATIONS_FRAGMENT}
    ${ENTITY_PROCESS_FRAGMENT}
`;

export const SENTRY_POLICY_MUTATION = gql`
    mutation UpdateSentryPolicy(
        $policy: ContinuousMonitoringInput!
        $runNow: Boolean!
    ) {
        setContinuousMonitoring(input: $policy, runNow: $runNow) {
            continuousMonitoring {
                ulid
                entityKey {
                    ulid
                }
                pollingFrequency
                searchEngine
                status
                monitorRelatedEntities
                createdDate
                clientName
            }
        }
    }
`;

export const GET_MONITORING_CONFIG = gql`
    query GetMonitoringSchema {
        ffmSchema: jsonSchema(schema: "elr.clients.ffm.schema.FFMProperties")
        clientConfig {
            showContinuousMonitoringModal
        }
    }
`;

export const GET_ENTITY_LOB_TERMINATIONS = gql`
    query GetEntityLobTerminations($ulid: String!) {
        lobTermination(entityUlid: $ulid) {
            ...LobTerminations
        }
    }
    ${ENTITY_LOB_TERMINATIONS_FRAGMENT}
`;

export const GET_ENTITY_MONITORING_CHANGES = gql`
    query GetEntityMonitoringChanges($ulid: ID!) {
        monitoringChanges(entityUlid: $ulid) {
            timestamp
            newMonitoringLevel
            oldMonitoringLevel
        }
    }
`;
